<!-- 
Vendor Edit 
	"./layouts/Dashboard.vue" .
 -->


<template>
  <div v-cloak>
    <div style="height: 50%; width: 100%">
      <loading :is-loading="isLoading"></loading>
    </div>
    <!-- header -->
    <div class="mb-50">
      <div class="mx-auto m-50" style="max-width: 800px">
        <div
          class="profile-nav-bg"
          style="background-image: url('images/bg-profile.jpg')"
        ></div>
        <div class="mx-auto m-50 border" style="max-width: 800px">
      <!-- Steps -->
     
      <!-- / Steps -->

      <!-- Steps tabs and forms -->
      <div class="mb-50 header-solid">
        <!-- Step 1 : Product Information -->
        <!-- <a-card
          v-if="step == 0"
          :bordered="false"
          class="header-solid"
          :bodyStyle="{ paddingTop: 0 }"
          :headStyle="{ paddingBottom: '0' }"
        > -->
          <template >
            <h5 class="mb-0">Home Owner Information</h5>
          </template>

          <!-- Product Information form -->
          <a-form :form="form"    aria-autocomplete="on">
            <a-row :gutter="[24]">
              <a-col :span="12">
                <a-form-item class="mb-10" label="First Name" :colon="false">
                  
                  <a-input
                  v-decorator="[
                    'First Name',
                    {
                      initialValue: homeowner.firstName,
                      rules: [
                        {
                          required: true,
                          message: 'Please provide First Name',
                        },
                      ],
                    },
                  ]"
                  placeholder="eg. Smith Painting LLC"
                />
                </a-form-item>
               
                  
              </a-col>
              <a-col :span="12">
                <a-form-item class="mb-10" label="Last Name" :colon="false">
                 
                  <a-input
                  v-decorator="[
                    'Last Name',
                    {
                      initialValue: homeowner.lastName,
                      rules: [
                        {
                          required: true,
                          message: 'Please provide Last Name',
                        },
                      ],
                    },
                  ]"
                  placeholder="eg. Smith Painting LLC"
                />
                </a-form-item>
              </a-col>
            </a-row>
             <template >
            <h5 class="mb-0">Contact Details</h5>
          </template>
             <a-row :gutter="[24]">
              <a-col :span="12">
                <a-form-item class="mb-10" label="Contact Name" :colon="false">
                  
                  <a-input
                  v-decorator="[
                    'Contact Name',
                    {
                      initialValue: homeowner.contactDetails.contactName,
                      rules: [
                        {
                          required: true,
                          message: 'Please provide Contact Name',
                        },
                      ],
                    },
                  ]"
                  placeholder="eg. Smith Painting LLC"
                />
                  
                </a-form-item>
               
              </a-col>
              <a-col :span="12">
                <a-form-item class="mb-10" label="Phone 1" :colon="false">
                  
                  <a-input
                  v-decorator="[
                    'Phone 1',
                    {
                      initialValue: homeowner.contactDetails.phone,
                      rules: [
                        {
                          required: true,
                          message: 'Please provide Phone 1',
                        },
                      ],
                    },
                  ]"
                  placeholder="eg. Smith Painting LLC"
                />
                </a-form-item>
              </a-col>
            </a-row>
            
             <a-row :gutter="[24]">
              <a-col :span="12">
                <a-form-item class="mb-10" label="Phone 2" :colon="false">
                  
                  <a-input
                  v-decorator="[
                    'Phone 2',
                    {
                      initialValue: homeowner.contactDetails.phone2,
                      rules: [
                        {
                          required: true,
                          message: 'Please provide Phone 2',
                        },
                      ],
                    },
                  ]"
                  placeholder="eg. Smith Painting LLC"
                />
                </a-form-item>
               
              </a-col>
              <a-col :span="12">
                <a-form-item class="mb-10" label="Email" :colon="false">
                 
                  <a-input
                  v-decorator="[
                    'Email',
                    {
                      initialValue: homeowner.contactDetails.email,
                      rules: [
                        {
                          required: true,
                          message: 'Please provide Email',
                        },
                      ],
                    },
                  ]"
                  placeholder="eg. Email"
                />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item class="mb-10" label="Fax" :colon="false">
                
                  <a-input
                  v-decorator="[
                    'Fax',
                    {
                      initialValue: homeowner.contactDetails.fax,
                      rules: [
                        {
                          required: true,
                          message: 'Please provide Fax',
                        },
                      ],
                    },
                  ]"
                  placeholder="eg. Fax"
                />
                </a-form-item>
              </a-col>
            </a-row>

            <template >
            <h5 class="mb-0">Spouse Reference</h5>
            </template>
              <a-row :gutter="[24]">
              <a-col :span="12">
               
                <a-form-item class="mb-10" label="Name" :colon="false">
                  <a-select
                     v-model="homeowner.spouseReference.id"
                    default-value=""
                  >
                   
                    <a-select-option value="">null</a-select-option>
                  
                  </a-select>
                </a-form-item>
              </a-col>
              
            </a-row>
            <template >
            <h5 class="mb-0">Address</h5>
            </template>
              <a-row :gutter="[24]">
              <a-col :span="12">
                <a-form-item class="mb-10" label="Address 1" :colon="false">
    
                   <a-input
                  v-decorator="[
                    'Address 1',
                    {
                      initialValue: homeowner.address.address1,
                      rules: [
                        {
                          required: true,
                          message: 'Please Address 1',
                        },
                      ],
                    },
                  ]"
                  placeholder="eg. Address 1"
                />
                </a-form-item>
               
              </a-col>
              <a-col :span="12">
                <a-form-item class="mb-10" label="Address 2" :colon="false">
                  
                  <a-input
                  v-decorator="[
                    'Address 2',
                    {
                      initialValue: homeowner.address.address2,
                      rules: [
                        {
                          required: true,
                          message: 'Please Address 2',
                        },
                      ],
                    },
                  ]"
                  placeholder="eg. Address 2"
                />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item class="mb-10" label="City" :colon="false">
                  
                  <a-input
                  v-decorator="[
                    'City',
                    {
                      initialValue: homeowner.address.city,
                      rules: [
                        {
                          required: true,
                          message: 'Please City',
                        },
                      ],
                    },
                  ]"
                  placeholder="eg. City"
                />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item class="mb-10" label="State" :colon="false">
                
                  <a-input
                  v-decorator="[
                    'State',
                    {
                      initialValue: homeowner.address.state,
                      rules: [
                        {
                          required: true,
                          message: 'Please State',
                        },
                      ],
                    },
                  ]"
                  placeholder="eg. State"
                />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item class="mb-10" label="ZipCode" :colon="false">
                  
                  <a-input
                  v-decorator="[
                    'ZipCode',
                    {
                      initialValue: homeowner.address.zipCode,
                      rules: [
                        {
                          required: true,
                          message: 'Please ZipCode',
                        },
                      ],
                    },
                  ]"
                  placeholder="eg. ZipCode"
                />
                </a-form-item>
              </a-col>
            </a-row>
           <template >
            <h5 class="mb-0">Associations</h5>
            </template>
              <a-row :gutter="[24]">
              <a-col :span="12">
               
                <a-form-item class="mb-10" label="Associations" :colon="false">
                  <a-select
                   v-model="homeowner.associations.id"
                    default-value="Property Manager"
                  >
                    
                    <a-select-option value="33887096-a0f9-45e1-bef0-78632436cd03">Test Association</a-select-option>
                   
                  </a-select>
                </a-form-item>
              </a-col>
              
            </a-row>


            
            <a-row :gutter="[24]">
              
              
              <a-col :span="24" class="text-right">
                 <p v-if="success" class="successful text-left">
                Home Owner has been successfully updated.
              </p>
                   <a-button
                  type="primary"
                   @click="$router.push('/homeowners/homeowners-list')"
                   
                  class="px-25"
                  >Cancel</a-button
                >&nbsp;
                 <a-button
                  type="primary"
                  @click="handleSubmit"
                  class="px-25"
                  >Create</a-button
                > 
                
              </a-col>
            </a-row>
          </a-form>
          <!-- / Product Information form -->
        <!-- </a-card> -->

        <!-- Step 2 : Address Information -->
        

        <!-- Step 3 : Contact Information -->
      

        <!-- Step 4 : Insurance Information -->
      

        <!-- Step 5 : Insurance Attachments -->
      
      </div>
      <!-- / Steps tabs and forms -->
    </div>
      </div>
    </div>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "../../scss/pages/_vendorEdit.scss";
import loading from "../../components/Cards/CardPleaseWait.vue";

export default {
  components: {
    loading: loading,
  },
  data() {
    return {
      //vendor: {},
      isLoading: true,
      currentRoute: window.location.pathname,
      success: false,
      submitState: "SAVE",
      form: this.$form.createForm(this, { name: "EditHomeOwners" }),
    };
  },
  methods: {
    //Handles input validation after submission.
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          this.submitState = "Please Wait";
          this.homeowner.updatedDate = this.updateDate();
          this.$store
            .dispatch("homeowners/updateHomeOwner", this.homeowner)
            .then(() => {
              this.success = true;
              this.submitState = "SAVE";
              (res) => {
                console.log(res);
              };
            })
            .catch((error) => {
              console.log(error.response);
            });
        }
      });
    },
    updateDate() {
      var currentdate = new Date();
      currentdate.getFullYear() +"-" +
        (currentdate.getMonth() + 1) +"-" +
        currentdate.getDate() +"T" +
        currentdate.getHours() +":" +
        currentdate.getMinutes() +":" +
        currentdate.getSeconds();
      return currentdate;
    },
  },
  computed: {
    homeowner: {
      get() {
          console.log("test",this.$store.state.homeowners.homeowner);
        return this.$store.state.homeowners.homeowner;
      },
    },
  },

  created() {
    this.$store
      .dispatch(`homeowners/getHomeOwner`, this.$route.params.id)
      .then(() => {
        this.isLoading = false;
      });
  },
};
</script>

<style lang="scss" scoped>
</style>
